import { useAuth } from '../contexts/auth-context.js';

const ROLE_FLAGS = {
    MANAGEMENT: {
        canApproveProperty: true,
        canAssignPortfolio: true,
        canViewAllPortfolios: true,
        canSubmitProperty: true,
        canManageLeases: true,
        canViewAllLeases: true,
        canCreateInspection: true,
        canAllocateTicket: true,
        canCreateMaintenanceTicket: true,
        canViewComplianceDocuments: true,
        canManageCompliance: true,
        canManageAllNotes: true,
        canSendMessages: true,
        canViewKPIDashboard: true,
        canManageContractors: true,
        canViewAllProperties: true
    },
    ADMIN: {
        canApproveProperty: true,
        canAssignPortfolio: true,
        canViewAllPortfolios: true,
        canSubmitProperty: true,
        canManageLeases: true,
        canViewAllLeases: true,
        canCreateInspection: true,
        canAllocateTicket: true,
        canCreateMaintenanceTicket: true,
        canViewComplianceDocuments: true,
        canManageCompliance: true,
        canManageAllNotes: true,
        canSendMessages: true,
        canViewKPIDashboard: false,
        canManageContractors: true,
        canViewAllProperties: true
    },
    AGENT: {
        canApproveProperty: false,
        canAssignPortfolio: false,
        canViewAllPortfolios: false,
        canSubmitProperty: true,
        canManageLeases: false,
        canViewAllLeases: false,
        canCreateInspection: true,
        canAllocateTicket: false,
        canCreateMaintenanceTicket: true,
        canViewComplianceDocuments: false,
        canManageCompliance: false,
        canManageAllNotes: false,
        canSendMessages: false,
        canViewKPIDashboard: false,
        canManageContractors: false,
        canViewAllProperties: false
    }
};

const EMPTY_FLAGS = Object.keys(ROLE_FLAGS.MANAGEMENT).reduce((acc, key) => {
    acc[key] = false;
    return acc;
}, {});

export const usePermissions = () => {
    const { user } = useAuth();
    const rentalRole = user?.user?.rentalRole || user?.rentalRole;
    return ROLE_FLAGS[rentalRole] || EMPTY_FLAGS;
};
